import { render, staticRenderFns } from "./tel-link.vue?vue&type=template&id=68390174&"
import script from "./tel-link.vue?vue&type=script&lang=js&"
export * from "./tel-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports